import {navText} from '../../src/js/functions';

jQuery(document).ready(function ($) {
    $('.block--vf-reviews-slider').each(function () {
        let owl = $(this).find('.owl-carousel');
        if (!owl) return;
        owl.owlCarousel({
            loop: true,
            dots: true,
            dotsEach: true,
            nav: true,
            center: true,
            margin: 8,
            items: 1,
            responsive: {
                768: {
                    items: 2,
                },
                992: {
                    margin: 24,
                    items: 3,
                }
            },
            navText: navText('#8C9AA6'),
        });
    });
});